import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { MessageImagesThreeImagesGridLayout } from '../MessageImagesThreeImagesGridLayout';
import { MessageImagesThreeImagesInRowLayout } from '../MessageImagesThreeImagesInRowLayout';

interface IMessageImagesLayoutProps {
  images: React.ReactElement[];
  uniqueKey: string;
}

/**
 * Компонент верстки галереи из нескольких фото
 */
export const MessageImagesLayout: React.VFC<IMessageImagesLayoutProps> = ({ images, uniqueKey }) => {
  const groups: React.ReactElement[] = [];

  switch (images.length) {
    case 2:
      groups.push(
        <MessageImagesThreeImagesInRowLayout images={images} key={`${uniqueKey}_size_${images.length}_row_1`} />,
      );
      break;
    case 3:
      groups.push(
        <MessageImagesThreeImagesGridLayout
          images={images}
          isReverseOrder={false}
          key={`${uniqueKey}_size_${images.length}_row_1`}
        />,
      );
      break;
    case 4:
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(0, 2)}
          key={`${uniqueKey}_size_${images.length}_row_1`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(2, 4)}
          key={`${uniqueKey}_size_${images.length}_row_2`}
        />,
      );
      break;
    case 5:
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(0, 2)}
          key={`${uniqueKey}_size_${images.length}_row_1`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesGridLayout
          images={images.slice(2, 5)}
          isReverseOrder={false}
          key={`${uniqueKey}_size_${images.length}_row_2`}
        />,
      );
      break;
    case 6:
      groups.push(
        <MessageImagesThreeImagesGridLayout
          images={images.slice(0, 3)}
          isReverseOrder={false}
          key={`${uniqueKey}_size_${images.length}_row_1`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesGridLayout
          images={images.slice(3, 6)}
          isReverseOrder={true}
          key={`${uniqueKey}_size_${images.length}_row_2`}
        />,
      );
      break;
    case 7:
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(0, 2)}
          key={`${uniqueKey}_size_${images.length}_row_1`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(2, 4)}
          key={`${uniqueKey}_size_${images.length}_row_2`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(4, 7)}
          key={`${uniqueKey}_size_${images.length}_row_3`}
        />,
      );
      break;
    case 8:
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(0, 2)}
          key={`${uniqueKey}_size_${images.length}_row_1`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(2, 5)}
          key={`${uniqueKey}_size_${images.length}_row_2`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(5, 8)}
          key={`${uniqueKey}_size_${images.length}_row_3`}
        />,
      );
      break;
    case 9:
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(0, 3)}
          key={`${uniqueKey}_size_${images.length}_row_1`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(3, 6)}
          key={`${uniqueKey}_size_${images.length}_row_2`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(6, 9)}
          key={`${uniqueKey}_size_${images.length}_row_3`}
        />,
      );
      break;
    case 10:
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(0, 2)}
          key={`${uniqueKey}_size_${images.length}_row_1`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(2, 4)}
          key={`${uniqueKey}_size_${images.length}_row_2`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(4, 7)}
          key={`${uniqueKey}_size_${images.length}_row_3`}
        />,
      );
      groups.push(
        <MessageImagesThreeImagesInRowLayout
          images={images.slice(7, 10)}
          key={`${uniqueKey}_size_${images.length}_row_4`}
        />,
      );
      break;
  }

  return (
    <div
      key={uniqueKey}
      data-testid="message_images_container"
      className={classNames(styles['container'], styles[`container--rows-${groups.length}`])}
    >
      {groups}
    </div>
  );
};
